import Layout from './Layout.component';

export default Layout;
